import _ from 'underscore';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuPopover,
  MenuTrigger,
  MenuItemRadio,
  mergeClasses,
} from '@fluentui/react-components';

import { FilterType } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useMenuStyle } from '../styles/context-menu-style';
/* istanbul ignore next */
export const NewFilterContextMenu = ({
  allSupportedFilters, filters, onAddNewFilter, i18n, isFocused,
}) => {
  const classes = useMenuStyle();
  const buttonRef = useRef();
  const [checkedValues, setCheckedValues] = useState();
  const items = useMemo(() => _.chain(allSupportedFilters)
    .values()
    .filter(f => f.type !== FilterType.SearchText) // can't add search text filter from context menu
    .map(({ type, title }) => {
      const isFilterAlreadySet = !!_.find(filters, { type });
      return {
        key: type,
        name: i18n.getString(title),
        disabled: isFilterAlreadySet,
        canCheck: true,
        checked: isFilterAlreadySet,
        onClick: () => {
          onAddNewFilter(type);
        },
      };
    })
    .value(), [allSupportedFilters, filters, i18n, onAddNewFilter]);

  useEffect(() => {
    const checkedItems = items.filter(item => item.checked).map(item => item.name);
    const newCheckedValues = {};
    checkedItems.forEach((item) => {
      newCheckedValues[item] = [undefined];
    });
    setCheckedValues(newCheckedValues);
  }, [items]);

  useEffect(() => {
    if (isFocused) {
      buttonRef.current.focus();
    }
  }, []);

  return (
    <Menu>
      <MenuTrigger>
        <MenuButton ref={buttonRef} className={mergeClasses('add-filter-button', classes.menuButton)}>{i18n.getString('Add filter')}</MenuButton>
      </MenuTrigger>

      <MenuPopover>
        <MenuList className="add-filter-menu-box" checkedValues={checkedValues}>
          {
            items.map(item => (
              <MenuItemRadio key={item.key} name={item.name} className={item.disabled ? 'disabled-menu-radio' : ''} disabled={item.disabled} onClick={item.onClick}>
                {item.name}
              </MenuItemRadio>
            ))
          }
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
/* istanbul ignore next */
NewFilterContextMenu.propTypes = {
  allSupportedFilters: PropTypes.shape({}).isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  target: PropTypes.shape({}),
  onAddNewFilter: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isFocused: PropTypes.bool,
};
/* istanbul ignore next */
NewFilterContextMenu.defaultProps = {
  filters: [],
  target: undefined,
  onAddNewFilter: _.noop,
  isFocused: false,
};
